export const SET_CREATE_COMPANY = "SET_CREATE_COMPANY";
export const SUBMIT_CREATE_COMPANY = "SUBMIT_CREATE_COMPANY";
export const CHECK_EXISTING_COMAPNY_URL = "CHECK_EXISTING_WEBSITE_URL";
export const CHECK_EXISTING_COMAPNY_URL_FULFILLED = "CHECK_EXISTING_COMAPNY_URL_FULFILLED";
export const CREATE_COMPANY_MODAL_ID = "create-company-modal";

export const STEP_CREATE_COMPANY_PAGE_IDENTITY = 0;
export const STEP_CREATE_COMPANY_DETAILS = 1;
export const STEP_CREATE_COMPANY_PROFILE = 2;
